<template>
    <div class="order-form-component">

        <!-- Introduction -->
        <div class="introduction">
            <div class="row">
                <div class="col-12">
                    <h3>{{ sectionOneHeading }}</h3>
                    <div v-html="description"></div>
                </div>
            </div>
        </div>

        <div class="your-details">
            <employee-and-additional-driver
                :driver-grade="driverGrade"
                :profile="driverProfile"
                :employeeIsMainDriver="employeeIsMainDriver"
                :additionalDrivers="additionalDrivers"
                :product="product"
                :session="session"
                :declaration="declaration">
            </employee-and-additional-driver>
        </div>


    </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import EmployeeAndAdditionalDriver from "../employee-and-additional-driver";
import VehicleCard from "../../vehicle-details/vehicle-card";

export default {
    components: {VehicleCard, EmployeeAndAdditionalDriver},

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.get();
        })
    },

    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        }

        if (to.name === 'Salary Sacrifice Product Details') {
            document.getElementById('order-process-wrap').scrollTo({top: 0, behavior: 'smooth'});

            if ( !this.confirmations.employeeDetails ) {
                EventBus.$emit('showError', true);
                EventBus.$emit('errorTitle', 'Please confirm all points to continue');
                EventBus.$emit('errorMessage', '');
                return false;
            }
        }

        next();
    },

    data() {
        return {
            employeeIsMainDriver: false,
            additionalDrivers: null,
        }
    },

    props: [
        'session',
        'driverGrade',
        'driverProfile',
        'confirmations',
        'adminPortalData',
        'sectionOneHeading'
    ],

    watch: {
        confirmations: {
            handler(confirmations) {
              EventBus.$emit('setConfirmations', confirmations);
            },
            deep: true
        }
    },

    computed: {
        product() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0] : null;
        },
        description() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_one_section_one_description : '';
        },
        declaration() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_one_declaration_text : '';
        },
    },

    methods: {
        get() {
            this.$http.get('/api/your-profile')
                .then(response => {
                    EventBus.$emit('loading', false);
                    this.employeeIsMainDriver = response.data.data.mainDriver;
                    this.additionalDrivers = response.data.data.additionalDrivers;
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.message
                    });
                    this.error = err.message.toString();
                    this.$router.push({name: response.redirect});
                });
        }
    }
}
</script>
